<div class="">
  <div class="panel-body b-r-6">
    <div class="header">
      <div class="radio-buttons">
        <label class="radio-button">
          <input type="radio" id="week" name="timeframe" value="week" [(ngModel)]="selectedTimeframe">
          Week
        </label>

        <label class="radio-button">
          <input type="radio" id="last30days" name="timeframe" value="last30days" [(ngModel)]="selectedTimeframe">
          Last 30 days
        </label>

        <label class="radio-button">
          <input type="radio" id="trend" name="timeframe" value="trend" [(ngModel)]="selectedTimeframe">
          YTD
        </label>

        <div class="toggle-container">
          <label>
            <input type="checkbox" [(ngModel)]="customSelected">
            <span class="slider"></span>
          </label>
          <span class="toggle-label"> Trend</span>
        </div>
      </div>
    </div>


    <div class="dashboard-container">
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">20000</div>
          <div class="label">Job Posted</div>
        </div>
        <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">20000</div>
          <div class="label">Job Applicants</div>
        </div>
        <ng-icon name="tablerUserCheck" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">20000</div>
          <div class="label">Job Invites sent</div>
        </div>
        <ng-icon name="tablerMailForward" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">20000</div>
          <div class="label">Job Invites Received</div>
        </div>
        <ng-icon name="tablerMail" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">5700</div>
          <div class="label">Candidates Posted</div>
        </div>
        <ng-icon name="tablerUserPlus" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">6000</div>
          <div class="label">Candidate Submissions</div>
        </div>
        <ng-icon name="tablerUsers" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">6000</div>
          <div class="label">Resume Request</div>
        </div>
        <ng-icon name="tablerChartBar" class="svg-position"></ng-icon>
      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">6000</div>
          <div class="label">Resume Request Received</div>
        </div>
        <ng-icon name="tablerMailForward" class="svg-position"></ng-icon>

      </div>
      <div class="dashboard-card">
        <div class="details">
          <div class="number fw-bold">6000</div>
          <div class="label">Resume Download</div>
        </div>
        <ng-icon name="tablerFileDownload" class="svg-position"></ng-icon>
      </div>
    </div>
    <div class="p-20">
      <p>*credits reset on the 1st day of the new billing cycle.</p>
      <p>**contact your customer success manager to increase your subscription quotas, or upgrade to a higher plan.
      </p>
    </div>
  </div>
</div>
